import React, { useEffect, useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink } from 'react-router-dom';
import { filter } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Button, Card, Checkbox, Container, FormControl, IconButton, InputLabel, Link, MenuItem, Paper, Popover, Select, Stack, Table, TableBody, TableCell, TableHead, TableContainer, TablePagination, TableRow, TextField, Typography, Tooltip, CardContent, Tab } from '@mui/material'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter, GridToolbar, GridToolbarExport } from '@mui/x-data-grid';
import Label from '../../common/common-sidebar/components/label/Label';
import Iconify from '../../common/common-sidebar/components/iconify';
import { toast } from 'react-toastify';
import loader from '../../images/loader.gif';
import moment from 'moment';
import { useNavigate } from "react-router-dom";

// sections
import { RequestListHead, RequestListToolbar } from '../../common/common-sidebar/components/sections/@dashboard/requests';

import { BaseURL } from '../../common/URLs';
import Context from '../../common/context/Abrplcontext';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { HELPDESK_ROLES } from '../../common/constants';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { loaderService } from '../../common/custom-loader/loader-service';
import CustomDataGridToolbar from '../../common/customDataGridToolbar';
import { AddIcon, AssignIcon, CloseTicketIcon, DeleteIcon, EditIcon, SubmitIcon } from '../../common/icons';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import apiClient from '../../axios';

// ----------------------------------------------------------------------
// const auth = "Bearer "+getLocalStorageItem('id_token');


const TABLE_HEAD = [
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'subject', label: 'Subject', alignRight: false },
  { id: 'firstName', label: 'Requester Name', alignRight: false },
  { id: 'technician', label: 'Support Executive', alignRight: false },
  { id: 'grievanceCategory', label: 'Category', alignRight: false },
  { id: 'grievanceSubCategory', label: 'Sub Category', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'dueDate', label: 'Due by date', alignRight: false },
  { id: 'raisedOnDate  ', label: 'Created Date', alignRight: false },
  { id: '' },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.id.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis?.map((el) => el[0]);
}

////.............................Main function to export......................////

function RequestsPage() {
  const { t } = useTranslation();
  const isAssigningRef = React.useRef(false);
  const [open, setOpen] = useState(null);
  const [openAssign, setOpenAssign] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [disableAssign, setDisableAssign] = useState(false)
  const [reqsttable, setRequesttable] = useState([]);
  const [technicianList, setTechnicianList] = useState([]);
  const [technician, setTechnician] = useState([]);
  const [refresh, setRefresh] = useState(true);
  // const [allTicket,setAllTicket]= useState([]);
  const [userdetails, setUserdetails] = useState([]);
  const [reqOption, setReqOption] = useState('Assigned');
  const navigate = useNavigate();
  const [tabValue, setTabValue] = React.useState('false');
  const [dropdownDisplay, setdropdownDisplay] = useState("none")
  const [assignDisplay, setAssignDisplay] = useState("none");
  const [userflag, setUserflag] = useState(0);
  const [selectionModel, setSelectionModel] = useState([]);
  const [selectedRowForAction, setSelectedRowForAction] = useState();
  const [selectedType, setSelectedType] = useState(null);
  const [isApiCalled, setIsApiCalled] = useState(false);

  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);

  const [logConfirmModalOpen2, setLogConfirmModalOpen2] = useState(false);
  const handleConfirmLogModalOpen2 = () => setLogConfirmModalOpen2(true);
  const handleConfirmLogModalClose2 = () => setLogConfirmModalOpen2(false);

  const [logConfirmModalOpen3, setLogConfirmModalOpen3] = useState(false);
  const handleConfirmLogModalOpen3 = () => setLogConfirmModalOpen3(true);
  const handleConfirmLogModalClose3 = () => setLogConfirmModalOpen3(false);


  const issueColumns = [
    {
      field: 'ticketNumber', headerName: t('helpdesk.id'), width: 110,
      renderCell: (params) => {
        return (
          <>
            <Link component={RouterLink} to={`grievance-resolution/${params?.row?.ticketNumber}`} style={{ cursor: "pointer" }}> {params?.row?.ticketNumber} </Link>
          </>
        )
      }
    },
    {
      field: 'grievanceDescription', headerName: t('helpdesk.subject'), width: 200,
      // cellClassName: Columnclasses.wrapText
    },
    { field: 'requesterName', headerName: t('helpdesk.requestedBy'), width: 230 },
    {
      field: 'firstName', headerName: t('helpdesk.requestedFor'), width: 230,
      renderCell: (params) => {
        let displayName = [params.row.firstName, params.row.middleName, params.row.lastName]
        let fullname = displayName?.filter(part => part).join(' ')
        return fullname
      }
    },
    // { field: 'requesterName', headerName: t('helpdesk.requesterName'), width: 230 },
    { field: 'requesterContactNo', headerName: t('helpdesk.contactNo'), width: 130 },
    {
      field: 'assignedto', headerName: t('helpdesk.supportExecutive'), width: 200,
      // cellClassName: Columnclasses.wrapText
    },
    { field: 'grievanceCategory', headerName: t('helpdesk.category'), width: 150 },
    { field: 'grievanceSubCategory', headerName: t('helpdesk.subCategory'), width: 180 },
    {
      field: 'status', headerName: t('helpdesk.status'), width: 150,
      renderCell: (params) => {
        return (
          <>
            <label color={(params?.row?.status === 'closed' && 'error') || 'success'} className='btn-alert'>{params?.row?.status} </label>
          </>
        )
      }
    },
    { field: 'dueDateStr', headerName: t('helpdesk.dueByDate'), width: 150 },
    { field: 'raisedDateStr', headerName: t('helpdesk.createdDate'), width: 150 },
    {
      field: 'violationFlag', headerName: "SLA Violated", width: 120,
      renderCell: (params) => {
        return (
          params.row.violationFlag === true ? "Yes" : "No"
        );
      }
    },
    {
      field: 'action', headerName: t('reg.actions'), width: 200,
      renderCell: (params) => {

        return (
          <>
            <Tooltip title="Edit">
              <IconButton size="large" color="primary" disabled={userflag === 1 && params?.row?.status === "awaiting for user response"} onClick={() => { setSelectedRowForAction(params.row); navigate(`grievance-resolution/${params?.row?.ticketNumber}`); }}>
                <EditIcon />
              </IconButton>
            </Tooltip>
            {(localStorage.getItem('role') === HELPDESK_ROLES?.ExternalAdminUser || localStorage.getItem('role') === HELPDESK_ROLES?.Admin || localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskAdminUser) &&
              <Tooltip title="Assign Ticket">
                <IconButton size="large" color="primary" disabled={params.row.status === "Closed"} onClick={(e) => { setSelectedRowForAction(params.row); assignTicket(e, params?.row) }} >
                  <AssignIcon />
                </IconButton>
              </Tooltip>}
            {(localStorage.getItem('role') === HELPDESK_ROLES?.ExternalAdminUser || localStorage.getItem('role') === HELPDESK_ROLES?.Admin || localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskAdminUser) &&
              <Tooltip title="Close Ticket"><IconButton size="large" color="primary" disabled={params.row.status === "Closed"} onClick={(e) => { setSelectedRowForAction(params.row); closeSingleTicket() }} >
                <CloseTicketIcon />
              </IconButton>
              </Tooltip>}
            {(localStorage.getItem('role') !== HELPDESK_ROLES?.HelpdeskSupportExecutive && localStorage.getItem('role') !== HELPDESK_ROLES?.ExternalSupportExecutive) &&
              <Tooltip title="Delete">
                <IconButton size="large" color="error" onClick={() => { setSelectedRowForAction(params.row); onDeleteTicket() }} >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>}
          </>
        )
      }
    }
  ]
  // const [data, getTicketListforAdmin, getTicketListfunc ] = ticketlist;
  const [data, setData] = useState([]);

  // --------------------------Print state variable here -----------------------//

  // useEffect(()=>{
  // },[reqsttable,allTicket])
  const convertDate = (date) => {
    return moment(date, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY HH:mm:ss')
  }

  const getTicketListforAdmin = (slaValue) => {
    loaderService.showLoader();
    apiClient.post(BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getTicketListForAdmin",
      {
        "violationFlg": slaValue ? slaValue : tabValue,
        "extFlag": (getLocalStorageItem('role') === HELPDESK_ROLES?.ExternalAdminUser || getLocalStorageItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) ? 1 : 0
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      // console.log("Data - ", response.data);
      let tempData = [...response.data];
      for (let index = 0; index < tempData?.length; index++) {
        const element = tempData[index];
        element.createdDateStr = convertDate(element.createdDateStr);
        element.dueDateStr = convertDate(element.dueDateStr);
        element.raisedDateStr = convertDate(element.raisedDateStr);
        element.updatedDateStr = convertDate(element.updatedDateStr);
      }
      setData(tempData);
      loaderService.hideLoader();
    }).catch((error) => {
      console.log(error);
      loaderService.hideLoader();
    })
  }

  const getTicketListforExecutive = (slaValue) => {
    loaderService.showLoader();
    apiClient.post(BaseURL + "/grievanceandhelpdesk/v1/helpdesk/findAssignedTicketList",
      {
        "violationFlg": slaValue ? slaValue : tabValue,
        // "extFlag": (getLocalStorageItem('role') === HELPDESK_ROLES?.ExternalAdminUser || getLocalStorageItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) ? 1 : 0
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      let tempData = [...response.data];
      for (let index = 0; index < tempData?.length; index++) {
        const element = tempData[index];
        element.createdDateStr = convertDate(element.createdDateStr);
        element.dueDateStr = convertDate(element.dueDateStr);
        element.raisedDateStr = convertDate(element.raisedDateStr);
        element.updatedDateStr = convertDate(element.updatedDateStr);
      }
      setData(tempData);
      loaderService.hideLoader();
    }).catch((error) => {
      console.log(error);
      loaderService.hideLoader();
    })
  }

  const getTicketListfunc = (slaValue) => {
    loaderService.showLoader();
    apiClient.post(BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getTicketList",
      {
        "violationFlg": slaValue ? slaValue : tabValue,
        // "extFlag": (getLocalStorageItem('role') === HELPDESK_ROLES?.ExternalAdminUser || getLocalStorageItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) ? 1 : 0
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      let tempData = [...response.data];
      for (let index = 0; index < tempData?.length; index++) {
        const element = tempData[index];
        element.createdDateStr = convertDate(element.createdDateStr);
        element.dueDateStr = convertDate(element.dueDateStr);
        element.raisedDateStr = convertDate(element.raisedDateStr);
        element.updatedDateStr = convertDate(element.updatedDateStr);
      }

      setData(tempData);
      loaderService.hideLoader();
    }).catch((error) => {
      console.log(error);
      loaderService.hideLoader();
    })
  }

  //......................Getting all ticket............................//
  useEffect(() => {
    // if (getLocalStorageItem('role')) {
    if (getLocalStorageItem('role') === HELPDESK_ROLES?.HelpdeskAdminUser || getLocalStorageItem('role') === HELPDESK_ROLES?.ExternalAdminUser) {
      getTicketListforAdmin();
    }
    else if (getLocalStorageItem('role') === HELPDESK_ROLES?.HelpdeskSupportExecutive || getLocalStorageItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) {
      getTicketListforExecutive();
    }
    else getTicketListfunc();
    // }
    // { refresh ? setRefresh(false) : setRefresh(true) };
  }, [userdetails])

  //......................filter ticket on category and use type basis.....................////

  // function Fn1(){
  useEffect(() => {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getUserDetails",
      {},
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      setUserdetails([response.data?.categoryName, response.data?.name, response.data?.usertype]);

    }).
      catch((error) => {
        console.log("error-- ", error)
      })
  }, [])
  //}


  useEffect(() => {
    const temp = [];
    let filteredData = data?.filter(item => item.extFlag === 1);

    //-----------This is technician--------------------//
    if (userdetails[2] === HELPDESK_ROLES?.ExternalSupportExecutive) {
      setdropdownDisplay("block");

      if (reqOption !== "category") {
        let ticketlist = filteredData?.filter(ticket => ticket.status === "Open");
        setRequesttable(ticketlist);
      }
      else {
        setRequesttable(filteredData);
      }
      setRequesttable(temp);
    }

    if (userdetails[2] === HELPDESK_ROLES?.ExternalAdminUser) {
      setAssignDisplay("block");
      setRequesttable(filteredData);
    }

    // else if (userdetails[2] === HELPDESK_ROLES?.HelpdeskSupportExecutive) {
    //   setdropdownDisplay("block");
    //   if (reqOption != "category") {
    //     for (var i = 0; i < data?.length; i++) {
    //       for (var j = 0; j < userdetails[0].length; j++) {
    //         if (data[i].grievanceCategory === userdetails[0][j]) {
    //           temp.push(data[i]);
    //         }
    //       }
    //     }
    //   }
    //   else {
    //     for (var i = 0; i < data?.length; i++) {
    //       if (data[i].assignedto === userdetails[1].trim()) {
    //         temp.push(data[i]);
    //       }
    //     }
    //   }
    //   setRequesttable(temp);
    // }

    else if (userdetails[2] === HELPDESK_ROLES?.Admin || userdetails[2] === HELPDESK_ROLES?.HelpdeskAdminUser) {
      setAssignDisplay("block");
      setRequesttable(data);
    }

    else if (userdetails[2] === HELPDESK_ROLES?.HelpdeskAssistant) {
      setUserflag(1);
      TABLE_HEAD[2].label = "Request created by me";
      for (var i = 0; i < data?.length; i++) {
        var name = data[i].firstName + " " + data[i].middleName + " " + data[i].lastName;
        if (name === userdetails[1]?.trim()) {
          temp.push(data[i]);
        }
      }
      setRequesttable(temp);

    }
    else {
      setUserflag(1);
      TABLE_HEAD[2].label = "Request created by me";
      for (var i = 0; i < data?.length; i++) {
        //   if (data[i].firstName === userdetails[1]?.trim()) {
        temp.push(data[i]);
        //   }
      }
      setRequesttable(temp);
    }
  }, [data, reqOption, userdetails])


  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
    setOpenAssign(null);
  };

  const handleChange = (e) => {
    setReqOption(e.target.value);
  };


  function assignTicket(e, row) {
    let inputs = row.grievanceCategory;
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getAllHelpDeskTeamMemByCategory",
      {
        "categoryReqst": [
          {
            "category": row.grievanceCategory
          }
        ]
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token'),
          "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0
        }
      }
    ).then((response) => {
      for (let index = 0; index < response.data.length; index++) {
        let displayName = [response.data[index].teamMemberFName, response.data[index].teamMemberMName, response.data[index].teamMemberLName]
        response.data[index]['fullname'] = displayName?.filter(part => part).join(' ')
      }
      if (row.ticketNumber?.startsWith('EXT') || selectedRowForAction?.ticketNumber?.startsWith('EXT')) {
        let data = response.data.filter(item => item.extFlag === 1);
        setTechnicianList(data)
      }
      if (row.ticketNumber?.startsWith('ABR') || selectedRowForAction?.ticketNumber?.startsWith('ABR')) {
        let data = response.data.filter(item => item.extFlag === 0);
        setTechnicianList(data)
      }
    }
    ).catch((error) => {
      console.log(error)
    })
    setOpenAssign(e.currentTarget);
    setOpen(null);
  }

  function handleTechnicianChange(e) {
    setTechnician(e.target.value);
    validateTechnician(e.target.value)
  }

  function validateTechnician(row) {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/uservalidationWithCat",
      {
        "categoryReqst": row.categoryReqst,
        "userEmailId": row.emailId,
        "extFlag": row.extFlag
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      if (response.data.haveAllAccess === "N") {
        let category = response.data.categoryReqst?.map(item => item?.category)?.join(", ");
        toast.error("Selected technician does not have access to" + " " + `${category}` + " " + "category(s)");
        setDisableAssign(true);
      }
      else setDisableAssign(false);
    }).catch((error) => {
      console.log(error)
      toast.error('Please try again !')
    })
  }

  function updateTechnician() {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/assignTicket",
      {
        "id": technician.id,
        "ticketNumber": selectedRowForAction?.ticketNumber,
        "assignedTo": technician.teamMemberFName + " " + technician.teamMemberMName + " " + technician.teamMemberLName,
        "category": selectedRowForAction?.grievanceCategory,
        "subCategory": selectedRowForAction?.grievanceSubCategory,
        "isActive": technician.isActive,
        "crtdBy": technician.crtdBy,
        "crtdOn": technician.crtdOn,
        "updtdOn": technician.updtdOn,
        "updtdBy": technician.updtdBy,
        "status": selectedRowForAction?.status,
        "documentContainer": technician.fileContainerName,
        "documentGuid": technician.fileGuid,
        "emailID": technician.emailId,
        "mobileNumber": technician.mobile,
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      if (response.data.status === "SUCCESS") {
        toast.success(response.data.description)
        if (localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskAdminUser) {
          getTicketListforAdmin();
        }
        else if (localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskSupportExecutive || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) {
          getTicketListforExecutive();
        }
        else getTicketListfunc();
      }
      else toast.error(response.data.description)
      // getTicketListfunc()
      setSelectedType(null);
    }).catch((error) => {
      console.log(error)
      toast.error('Please try again !')
    })
  }

  const closeSingleTicket = () => {
    handleConfirmLogModalOpen3();
  }

  // const onConfirmSubmit3 = () => {
  //   handleConfirmLogModalClose3();
  //   singleTicketClose();
  // }

    const onConfirmSubmit3 = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await singleTicketClose();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setLogConfirmModalOpen3(false);
      setIsApiCalled(false);
    }
  };

  function singleTicketClose() {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/closeTicket",
      {
        "id": selectedRowForAction?.id,
        "ticketNumber": selectedRowForAction?.ticketNumber,
        "status": "Closed",
        "closedOnTime": new Date().getTime,
        "closedOnDate": new Date().getDate,
        "updtdBy": selectedRowForAction?.firstName,
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      if (response.data.status === "SUCCESS") {
        toast.success(response.data.description)
        if (localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskAdminUser) {
          getTicketListforAdmin();
        }
        else if (localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskSupportExecutive || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) {
          getTicketListforExecutive();
        }
        else getTicketListfunc();
        setSelectedType(null);
      }
      else toast.error(response.data.description)
    }).catch((error) => {
      console.log(error)
      toast.error('Please try again !')
    })
  }

  const onDeleteTicket = () => {
    handleConfirmLogModalOpen();
  }

  // const onConfirmSubmit = () => {
  //   handleConfirmLogModalClose();
  //   deleteTicket();
  // }

  const onConfirmSubmit = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await deleteTicket();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setLogConfirmModalOpen(false);
      setIsApiCalled(false);
    }
  };

  function deleteTicket() {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/deleteOtherUserGrievanceRegById",
      {
        "id": selectedRowForAction?.id,
        "ticketNumber": selectedRowForAction?.ticketNumber,
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      if (response.data.status === "SUCCESS") {
        toast.success(response.data.description)
        if (localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskAdminUser) {
          getTicketListforAdmin();
        }
        else if (localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskSupportExecutive || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) {
          getTicketListforExecutive();
        }
        else getTicketListfunc();
        setSelectedType(null);
      }
      else toast.error(response.data.description)
    }).catch((error) => {
      console.log(error)
      toast.error('Please try again !')
    })
  }

  function handleMultipleAssignOpen(e) {
    setMultiAssignOpen(true);
    let allTickets = [...reqsttable];
    let tempArr = [];
    for (let index = 0; index < allTickets?.length; index++) {
      const element = allTickets[index];
      // Check if the current ticket is in the selection model
      if (selectionModel.includes(element.ticketNumber)) {
        if (element.status === "Closed") {
          toast.error("The ticket is already closed!");
          return; // Exit the function if any closed ticket is found
        }
        // Push category into the array
        tempArr.push({ category: element.grievanceCategory });
      }
    }
    // Prepare API payload in required format
    const apiPayload = {
      categoryReqst: tempArr,
    };
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getAllHelpDeskTeamMemByCategory",
      apiPayload,
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token'),
          "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0
        }
      }
    ).then((response) => {
      // setSelectionModel([])
      for (let index = 0; index < response.data.length; index++) {
        let displayName = [response.data[index].teamMemberFName, response.data[index].teamMemberMName, response.data[index].teamMemberLName]
        response.data[index]['fullname'] = displayName?.filter(part => part).join(' ')
      }
      if (selectionModel[0]?.startsWith('EXT')) {
        let data = response.data.filter(item => item.extFlag === 1);
        setTechnicianList(data)
      }
      if (selectionModel[0]?.startsWith('ABR')) {
        let data = response.data.filter(item => item.extFlag === 0);
        setTechnicianList(data)
      }
    }
    ).catch((error) => {
      toast.error(error.response)
      console.log(error)
    })

  }

  const [multiAssignOpen, setMultiAssignOpen] = React.useState(false);

  const handleClose = () => {
    setMultiAssignOpen(false);
  };

  // const assignTech = () => {
  //   handleClose();
  //   let allTickets = [...reqsttable];
  //   let multipleArr = [];
  //   for (let i = 0; i < allTickets?.length; i++) {
  //     let element = allTickets[i]
  //     for (let j = 0; j < selectionModel?.length; j++) {
  //       const selectedElement = selectionModel[j];
  //       if (selectedElement == element.ticketNumber) {
  //         var obj = {
  //           "id": element?.id ?? "",
  //           "ticketNumber": element?.ticketNumber ?? "",
  //           "assignedTo": technician.teamMemberFName + " " + technician.teamMemberMName + " " + technician.teamMemberLName,
  //           "subject": element?.grievanceDescription ?? "",
  //           "category": element?.grievanceCategory ?? "",
  //           "subCategory": element?.grievanceSubCategory ?? "",
  //           "isActive": technician.isActive,
  //           "crtdBy": technician.crtdBy,
  //           "crtdOn": technician.crtdOn,
  //           "updtdOn": technician.updtdOn,
  //           "updtdBy": technician.updtdBy,
  //           "requestType": element?.requestType ?? "",
  //           "status": element?.status ?? "",
  //           "documentContainer": technician.fileContainerName,
  //           "documentGuid": technician.fileGuid,
  //           "emailID": technician.emailId,
  //           "mobileNumber": technician.mobile,
  //           "dueDateStr": element?.dueDateStr ?? "",
  //           "createdDateStr": element?.createdDateStr ?? "",
  //           "updatedDateStr": element?.updatedDateStr ?? ""
  //         }
  //         multipleArr.push(obj);
  //       }
  //     }
  //   }
  //   let multipleAssigned = { helpdeskTicketAssignment: multipleArr }
  //   loaderService.showLoader();
  //   apiClient.post(
  //     BaseURL + "/grievanceandhelpdesk/v1/helpdesk/multTicketAssign",
  //     multipleAssigned,
  //     {
  //       headers: {
  //         Authorization: "Bearer " + getLocalStorageItem('id_token'),
  //       }
  //     }
  //   ).then((response) => {
  //     if (localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskAdminUser) {
  //       getTicketListforAdmin();
  //     }
  //     else if (localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskSupportExecutive || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) {
  //       getTicketListforExecutive();
  //     }
  //     else getTicketListfunc();
  //     // getTicketListfunc()
  //     toast.success(response.data.description);
  //     setSelectedType(null);
  //     setSelectionModel([]);
  //     loaderService.hideLoader();
  //   }
  //   ).catch((error) => {
  //     toast.error(error.response.description);
  //     console.log(error);
  //     loaderService.hideLoader();
  //   })

  // }

  const assignTech = async () => {
    if (isAssigningRef.current) return;
    isAssigningRef.current = true;

    try {
      handleClose();

      const allTickets = Array.isArray(reqsttable) ? [...reqsttable] : [];
      const selectedSet = new Set(selectionModel ?? []);
      const multipleArr = [];

      for (let i = 0; i < allTickets.length; i++) {
        const element = allTickets[i];
        if (selectedSet.has(element?.ticketNumber)) {
          multipleArr.push({
            id: element?.id ?? "",
            ticketNumber: element?.ticketNumber ?? "",
            assignedTo:
              (technician?.teamMemberFName ?? "") +
              " " +
              (technician?.teamMemberMName ?? "") +
              " " +
              (technician?.teamMemberLName ?? ""),
            subject: element?.grievanceDescription ?? "",
            category: element?.grievanceCategory ?? "",
            subCategory: element?.grievanceSubCategory ?? "",
            isActive: technician?.isActive,
            crtdBy: technician?.crtdBy,
            crtdOn: technician?.crtdOn,
            updtdOn: technician?.updtdOn,
            updtdBy: technician?.updtdBy,
            requestType: element?.requestType ?? "",
            status: element?.status ?? "",
            documentContainer: technician?.fileContainerName,
            documentGuid: technician?.fileGuid,
            emailID: technician?.emailId,
            mobileNumber: technician?.mobile,
            dueDateStr: element?.dueDateStr ?? "",
            createdDateStr: element?.createdDateStr ?? "",
            updatedDateStr: element?.updatedDateStr ?? "",
          });
        }
      }

      const multipleAssigned = { helpdeskTicketAssignment: multipleArr };

      loaderService.showLoader();

      const response = await apiClient.post(
        BaseURL + "/grievanceandhelpdesk/v1/helpdesk/multTicketAssign",
        multipleAssigned,
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      );

      const role = localStorage.getItem("role");
      if (role === HELPDESK_ROLES?.HelpdeskAdminUser) {
        await (getTicketListforAdmin?.() ?? Promise.resolve());
      } else if (
        role === HELPDESK_ROLES?.HelpdeskSupportExecutive ||
        role === HELPDESK_ROLES?.ExternalSupportExecutive
      ) {
        await (getTicketListforExecutive?.() ?? Promise.resolve());
      } else {
        await (getTicketListfunc?.() ?? Promise.resolve());
      }

      toast.success(response?.data?.description ?? "Assigned successfully");
      setSelectedType?.(null);
      setSelectionModel?.([]);
    } catch (error) {
      const msg =
        error?.response?.description ||
        error?.response?.data?.description ||
        error?.message ||
        "Something went wrong";
      toast.error(msg);
      console.log(error);
    } finally {
      loaderService.hideLoader();
      isAssigningRef.current = false;
    }
  };


  const onMultiTicketClose = () => {
    handleConfirmLogModalOpen2();
  }

  // const onConfirmSubmit2 = () => {
  //   handleConfirmLogModalClose2();
  //   colseMultipleTickets();
  // }

  const onConfirmSubmit2 = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await colseMultipleTickets();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setLogConfirmModalOpen2(false);
      setIsApiCalled(false);
    }
  };

  function colseMultipleTickets(e) {
    let allTickets = [...reqsttable];
    let tempArr = [];
    for (let index = 0; index < allTickets?.length; index++) {
      const element = allTickets[index];

      for (let j = 0; j < selectionModel?.length; j++) {
        const selectedElement = selectionModel[j];
        if (selectedElement == element.ticketNumber) {
          if (element.status == "Closed") {
            toast.error("The ticket is already closed!")
            return
          }
          let obj = {
            "id": element.id ?? "",
            "ticketNumber": element?.ticketNumber ?? "",
            "status": "Closed",
            "closedOnTime": new Date().getTime,
            "closedOnDate": new Date().getDate,
            "updtdBy": element?.updtdBy ?? "",
            "updtdOn": new Date().getDate
          };
          tempArr.push(obj);
        }
      }
    }

    var obj = {
      "closeTicketPojo": tempArr
    }
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/closeMultipleTicket",
      obj,
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token'),
        }
      }
    ).then((response) => {
      if (localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskAdminUser) {
        getTicketListforAdmin();
      }
      else if (localStorage.getItem('role') === HELPDESK_ROLES?.HelpdeskSupportExecutive || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) {
        getTicketListforExecutive();
      }
      else getTicketListfunc();
      // getTicketListfunc();
      toast.success(response.data.description);
      setSelectedType(null);
      setSelectionModel([]);
    }
    ).catch((error) => {
      toast.error(error.response.description)
      console.log(error)
    })
  }

  const handleSelectionChange = (selection) => {
    if (selection.length === 0) {
      setSelectedType(null); // Reset when nothing is selected
      setSelectionModel([]);
      return;
    }
    const selectedTicket = reqsttable?.filter((row) => row.ticketNumber?.includes(selection[0]));
    const type = selectedTicket[0]?.extFlag === 1 ? "EXT" : "ABR";
    setSelectedType(type);
    setSelectionModel(selection);
  };

  const handleTabChange = (event, slaValue) => {
    setTabValue(slaValue);
    if (getLocalStorageItem('role') === HELPDESK_ROLES?.HelpdeskAdminUser || getLocalStorageItem('role') === HELPDESK_ROLES?.ExternalAdminUser) {
      getTicketListforAdmin(slaValue);
    }
    else if (getLocalStorageItem('role') === HELPDESK_ROLES?.HelpdeskSupportExecutive || getLocalStorageItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) {
      getTicketListforExecutive(slaValue);
    }
    else getTicketListfunc(slaValue);
  };

  return (
    <>
      <Helmet>
        <title> Requests | ABEPL </title>
      </Helmet>
      <Container maxWidth="xxl" >
        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            {t('sidebarStakeholder.requests')}
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
            <>
              <Stack direction="row" spacing={1}>
                {
                  ((userdetails[2] == HELPDESK_ROLES?.StakeHolder) || (userdetails[2] == HELPDESK_ROLES?.HelpdeskAssistant) || (userdetails[2] == HELPDESK_ROLES.GuestUser)) ?
                    <Button component={RouterLink} to='new-incident' variant="contained" startIcon={<AddIcon />}>
                      {t('helpdesk.newIncident')}
                    </Button>
                    : null}
                {
                  (userdetails[2] == HELPDESK_ROLES?.HelpdeskAssistant || userdetails[2] == HELPDESK_ROLES?.ExternalAdminUser || userdetails[2] == HELPDESK_ROLES?.HelpdeskAdminUser) ?
                    <Button component={RouterLink} to='new-external-incident' variant="contained" startIcon={<AddIcon />}>
                      External New Incident
                    </Button>
                    : null}
                <Button startIcon={<AssignIcon />} hidden={localStorage.getItem('stakeholderCategory')} disabled={selectionModel?.length === 0} onClick={(e) => { handleMultipleAssignOpen(e) }} variant="contained">
                  Assign Ticket
                </Button>
                <Button startIcon={<CloseTicketIcon />} hidden={localStorage.getItem('stakeholderCategory')} disabled={selectionModel?.length === 0} onClick={(e) => { onMultiTicketClose(e) }} variant="outlined">
                  Close Ticket
                </Button>
              </Stack>
            </>
          </Stack>
        </Stack>
        <Card>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                <Tab label="Requests" value="false" />
                <Tab label="SLA Violated Requests" value="true" />
              </TabList>
            </Box>
            <TabPanel value='false'>
              {/* <Card>
                <CardContent> */}
              <FormControl xs={6} sm={6} md={6} style={{ display: `${dropdownDisplay}` }}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={reqOption}
                  defaultValue={reqOption}
                  // label="Age"
                  onChange={handleChange}
                >
                  <MenuItem value='category'>All Request in my category</MenuItem>
                  <MenuItem value='Assigned'>Request Assigned to me</MenuItem>
                </Select>
              </FormControl>
              {/* </CardContent>
              </Card> */}
              {reqsttable?.length < 1 ?
                <div>
                  <h4>{t('helpdesk.dontHaveAnyTicket')}</h4>
                </div>
                :
                <Box sx={{ height: 400, width: '100%' }}>
                  <DataGrid
                    rows={reqsttable}
                    getRowId={(row) => row?.ticketNumber}
                    columns={issueColumns}
                    getRowClassName={(params) =>
                      params.row.violationFlag === true ? 'highlightRow' : ''
                    }
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    checkboxSelection={!localStorage.getItem('stakeholderCategory')}
                    onSelectionModelChange={(e) => handleSelectionChange(e)}
                    selectionModel={selectionModel}
                    isRowSelectable={(params) => params.row.status !== "Closed" && (!selectedType || params.row.ticketNumber?.startsWith(selectedType))} // Disable opposite type selection
                    disableSelectionOnClick
                    components={{
                      Toolbar: CustomDataGridToolbar,
                    }}
                    componentsProps={{ toolbar: { rows: reqsttable, columns: issueColumns, fileName: "TicketList.xlsx" } }}
                  />
                </Box>

              }

            </TabPanel>
            <TabPanel value='true'>
              {/* <Card>
                <CardContent> */}
              <FormControl xs={6} sm={6} md={6} style={{ display: `${dropdownDisplay}` }}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={reqOption}
                  defaultValue={reqOption}
                  // label="Age"
                  onChange={handleChange}
                >
                  <MenuItem value='category'>All Request in my category</MenuItem>
                  <MenuItem value='Assigned'>Request Assigned to me</MenuItem>
                </Select>
              </FormControl>
              {reqsttable?.length < 1 ?
                <div>
                  <h4>{t('helpdesk.dontHaveAnyTicket')}</h4>
                </div>
                :
                <Box sx={{ height: 400, width: '100%' }}>
                  <DataGrid
                    rows={reqsttable}
                    getRowId={(row) => row?.ticketNumber}
                    columns={issueColumns}
                    getRowClassName={(params) =>
                      params.row.violationFlag === true ? 'highlightRow' : ''
                    }
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    checkboxSelection={!localStorage.getItem('stakeholderCategory')}
                    // onSelectionModelChange={(newSelectionModel) => {
                    //   setSelectionModel(newSelectionModel);
                    // }}
                    onSelectionModelChange={(e) => handleSelectionChange(e)}
                    selectionModel={selectionModel}
                    isRowSelectable={(params) => params.row.status !== "Closed" && (!selectedType || params.row.ticketNumber?.startsWith(selectedType))} // Disable opposite type selection
                    disableSelectionOnClick
                    components={{
                      Toolbar: CustomDataGridToolbar,
                    }}
                    componentsProps={{ toolbar: { rows: reqsttable, columns: issueColumns, fileName: "TicketList.xlsx" } }}
                  />
                </Box>

              }
              {/* </CardContent>
              </Card> */}
            </TabPanel>
          </TabContext>
        </Card>


        {/* CARD DIALOG MULTIPLE ASSIGN  */}
        <Dialog open={multiAssignOpen} onClose={handleClose}>
          <DialogTitle>Assign Ticket to Technician</DialogTitle>
          <DialogContent>
            {/* <DialogContentText>
                    Assign Ticket to Technician
                  </DialogContentText> */}

            <Table aria-label="simple table" xs={12} md={6}>
              <TableBody>
                <TableRow>
                  <TableCell align="left" style={{ width: '150px' }}>Ticket No./No.s -</TableCell>
                  <TableCell align="center" style={{ width: '500px', wordBreak: 'break-word' }}>
                    <div className='d-flex flex-wrap'>{selectionModel.map((item) => { return (<p key={item} className='alert alert-warning p-1 me-2' style={{ fontSize: 12 }}>{item}</p>) })}</div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={{ width: '150px' }}>Assign To</TableCell>
                  <TableCell align="center">
                    <FormControl fullWidth size="small">
                      <InputLabel id="demo-simple-select-label">Technician</InputLabel>
                      <Select
                        labelId="select-technician-label"
                        id="select-technician"
                        label="technician"
                        defaultValue={""}
                        // value={category}
                        onChange={(e) => { handleTechnicianChange(e) }}
                      //onClick={() => fetchCategory()}
                      >
                        <MenuItem value="">
                          <em>Select</em>
                        </MenuItem>
                        {technicianList?.map(function (technician, i) {
                          return <MenuItem key={i} value={technician}>{technician.fullname}</MenuItem>
                        })}
                        {/* <MenuItem value={1}>Registration</MenuItem> */}
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>

          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined">Cancel</Button>
            <Button disabled={technician?.length === 0 || disableAssign || isAssigningRef.current} onClick={() => { assignTech() }} variant="contained" >Assign Technician</Button>
          </DialogActions>
        </Dialog>

      </Container>

      {/* ............................Popover for Assign ticket method......................................... */}

      <Popover open={Boolean(openAssign)}
        //anchorEl={openAssign}
        onClose={handleCloseMenu}
        //anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
        //transformOrigin={{ vertical: 'center', horizontal: 'center' }}
        anchorReference={"none"}
        // classes={{
        //   root: classes.popoverRoot,
        // }}


        PaperProps={{
          sx: {
            p: 1,
            width: '650px',
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,

            },
          },
        }}
      >
        {/* <Card> */}
        {/* <TableContainer component={Paper}> */}
        <div style={{ padding: '3%' }}>
          <Stack direction="row" justifyContent='space-between'>
            <h4 style={{ display: "inline" }}>Assign Ticket to Technician</h4>
            <Button onClick={handleCloseMenu}>X</Button>

          </Stack>

          <Table aria-label="simple table" xs={12} md={6}>
            <TableBody>
              <TableRow>
                <TableCell align="left">Ticket No -</TableCell>
                <TableCell align="center"> {selectedRowForAction?.ticketNumber}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">Category</TableCell>
                <TableCell align="center">{selectedRowForAction?.grievanceCategory}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">SubCategory</TableCell>
                <TableCell align="center">{selectedRowForAction?.grievanceSubCategory}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">Due Date</TableCell>
                <TableCell align="center">{selectedRowForAction?.dueDateStr}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">Status</TableCell>
                <TableCell align="center">{selectedRowForAction?.status}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">Assign To</TableCell>
                <TableCell align="center">
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">Technician</InputLabel>
                    <Select
                      labelId="select-technician-label"
                      id="select-technician"
                      label="technician"
                      defaultValue={""}
                      // value={category}
                      onChange={(e) => { handleTechnicianChange(e) }}
                    //onClick={() => fetchCategory()}
                    >
                      <MenuItem value="">
                        <em>Select</em>
                      </MenuItem>
                      {technicianList?.map(function (technician, i) {
                        return <MenuItem key={i} value={technician}>{technician.fullname}</MenuItem>
                      })}
                      {/* <MenuItem value={1}>Registration</MenuItem> */}
                    </Select>
                  </FormControl>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          {/* </TableContainer> */}
          <br />
          <Button variant="contained"
            style={{ marginLeft: "30%" }}
            onClick={() => {
              updateTechnician();
              handleCloseMenu();
              ;
            }}
            endIcon={<SubmitIcon />}
          >
            Submit
          </Button>
        </div>
        {/* </Card> */}
      </Popover>
      <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmLogModalClose} action="Delete Ticket" />
      <ConfirmationPopover onOpen={logConfirmModalOpen2} onConfirm={onConfirmSubmit2} onClose={handleConfirmLogModalClose2} action="Close Ticket" />
      <ConfirmationPopover onOpen={logConfirmModalOpen3} onConfirm={onConfirmSubmit3} onClose={handleConfirmLogModalClose3} action="Close Ticket" />
    </>
  )
}

export default RequestsPage